export const applyHistory = (startAssignees: string[], history: string[]) => {
  // Update task assignees based off history of selections
  const newAssignees = history.reduce((assigneesList, currentID) => {
    const shouldAdd = !assigneesList.includes(currentID)

    if (shouldAdd) {
      return [...assigneesList, currentID]
    }

    return assigneesList.filter(id => id !== currentID)
  }, startAssignees)

  return newAssignees
}
